<script>
import { Doughnut } from 'vue-chartjs'

export default {
  name: 'DoughnutChart',
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    data: {
      type: Array
    },
    options: {
      type: Object,
      default: null
    }
  },
  watch: {
   data: function (data) {
     // Watch for changes in data
     this.chartdata.datasets[0].data = [];
     this.chartdata.datasets[0].data = data;
     // Reset data and destroy chart
     this.$data._chart.destroy();
     // Render chart again with new data
     this.renderChart(this.chartdata, this.options);
   }
 },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}

</script>
